import Vue from 'vue';
import skySharethis from './sky-sharethis';

Vue.component('sky-sharethis', skySharethis);

export default skySharethis;



// WEBPACK FOOTER //
// ./scripts/sky-sharethis/index.js